import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";

const THEME_KEY = "jusfy-theme";

function getTheme() {
  try {
    return localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light";
  } catch (er) {
    return "light";
  }
}

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

// Páginas sem dark mode (LegalDocuments, Jusfinder) chamam useLightOnly():
// o html fica light enquanto estiverem montadas, sem mexer na escolha salva.
export function useLightOnly() {
  const { setLightOnly } = useTheme();
  useEffect(() => {
    setLightOnly(true);
    return () => setLightOnly(false);
  }, [setLightOnly]);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getTheme);
  const [lightOnly, setLightOnly] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch (er) {
      // storage indisponível: tema vale só na sessão
    }
  }, [theme]);

  useEffect(() => {
    document.documentElement.dataset.theme = lightOnly ? "light" : theme;
  }, [theme, lightOnly]);

  const value = useMemo(
    () => ({
      theme,
      lightOnly,
      setLightOnly,
      toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark"))
    }),
    [theme, lightOnly]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}
